let headerHeight = 0;

function isPc() {
  return window.innerWidth >= 768;
}

function isMobile() {
  return !isPc();
}

/**
 * スムーススクロール共通処理
 * @param {string} targetId - スクロール先のセレクタ
 * @param {number} speed - アニメーション速度（デフォルト: 500）
 * @param {number} offset - オフセット値（デフォルト: headerHeight）
 */
function smoothScrollTo(targetId, speed = 500, offset = null) {
  const target = jQuery(targetId);
  if (!target.length) return;

  let position = target.offset().top;
  const adjustOffset = offset !== null ? offset : headerHeight;

  if (['fixed', 'sticky'].includes(jQuery('#header').css('position'))) {
    position -= adjustOffset;
  }

  if (position < 0) position = 0;

  jQuery('html, body').animate({ scrollTop: position }, speed);
}

/**
 * アンカーリンク（ページロード時）
 */
function scrollHash() {
  const hash = location.hash;
  if (hash && jQuery(hash).length) {
    window.scrollTo(0, 0);
    setTimeout(() => {
      smoothScrollTo(hash, 500);
    }, 300);
  }
}

/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

/**
 * スクロールバーを除いた画面幅・高さの取得 → CSS カスタムプロパティに反映
 */
function updateFvSliderHeight() {
  const fvImageSp = document.querySelector('.fv__image-sp');
  if (!fvImageSp || !isMobile()) return;

  const fvSpHeight = fvImageSp.offsetHeight;
  if (!fvSpHeight) return;

  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const rem20 = rootFontSize * 1.25;
  const rem40 = rootFontSize * 2.5;

  const sliderHeight = Math.max((window.innerHeight - headerHeight - rem20 - (fvSpHeight - rem40)) / 2, 0);
  const gap = Math.max(fvSpHeight - rem40, 0);

  document.documentElement.style.setProperty('--fv-slider-height', `${sliderHeight}px`);
  document.documentElement.style.setProperty('--fv-gap', `${gap}px`);
}

function equalCaseItemHeight() {
  const items = document.querySelectorAll('.case__item');
  if (!items.length) return;

  items.forEach((el) => (el.style.minHeight = ''));

  if (!isPc()) return;

  let maxHeight = 0;
  items.forEach((el) => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });
  items.forEach((el) => {
    el.style.minHeight = maxHeight + 'px';
  });
}

jQuery(window).on('load resize', function () {
  const vw = document.body.clientWidth;
  const vh = window.innerHeight;
  headerHeight = document.querySelector('.js-header')?.offsetHeight ?? 0;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vw-unitless', `${vw}`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  updateFvSliderHeight();
  equalCaseItemHeight();
});

jQuery(window).on('load', function () {
  jQuery('body').attr('data-loading', 'true');
  scrollHash();
});

jQuery(function () {
  /* FV スライダー --------------------------------------------------------------- */
  if (document.querySelector('.js-fv-before') && document.querySelector('.js-fv-after')) {
    const fvBefore = new Swiper('.js-fv-before', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      direction: 'vertical',
      allowTouchMove: false,
    });

    const fvAfter = new Swiper('.js-fv-after', {
      loop: true,
      speed: 1000,
      allowTouchMove: false,
      direction: 'vertical',
    });

    fvBefore.controller.control = fvAfter;
    fvAfter.controller.control = fvBefore;
  }

  /* shop スライダー --------------------------------------------------------------- */
  if (document.querySelector('.js-shop-slider')) {
    new Swiper('.js-shop-slider', {
      loop: true,
      loopedSlides: 4,
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        prevEl: '.js-shop-slider-prev',
        nextEl: '.js-shop-slider-next',
      },
    });
  }

  /* ドロワー --------------------------------------------------------------- */
  jQuery('.js-drawer').on('click', function (event) {
    event.preventDefault();

    const ariaControls = jQuery(this).attr('aria-controls');
    const addClass = 'is-opened';
    const $drawer = jQuery(`#${ariaControls}`);
    const $header = jQuery('.js-header');

    $drawer.toggleClass(addClass);

    const isOpened = $drawer.hasClass(addClass);

    $drawer.attr('aria-hidden', isOpened ? 'false' : 'true');
    $header.toggleClass(addClass, isOpened);
    jQuery('body').toggleClass('u-overflowHidden', isOpened);

    jQuery(`[aria-controls="${ariaControls}"]`).each(function () {
      jQuery(this).attr('aria-expanded', isOpened ? 'true' : 'false');
      jQuery(this).toggleClass(addClass, isOpened);
    });

    jQuery(this).attr('aria-label', isOpened ? 'メニューを閉じる' : 'メニューを開く');

    return false;
  });

  /* オーバーレイクリックでドロワーを閉じる --------------------------------- */
  jQuery('.js-drawer-overlay').on('click', function () {
    const $drawer = jQuery('#drawer');
    $drawer.removeClass('is-opened').attr('aria-hidden', 'true');
    jQuery('.js-header').removeClass('is-opened');
    jQuery('.js-drawer').attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く').removeClass('is-opened');
    jQuery('body').removeClass('u-overflowHidden');
  });

  /* ドロワー内のページ内リンククリック時に閉じる --------------------------- */
  jQuery('#drawer a[href*="#"]').on('click', function () {
    const currentUrl = location.protocol + '//' + location.host + location.pathname;
    const href = jQuery(this).prop('href');
    const hrefUrl = href.split('#')[0];

    if (currentUrl === hrefUrl) {
      const $drawer = jQuery('#drawer');
      $drawer.removeClass('is-opened').attr('aria-hidden', 'true');
      jQuery('.js-header').removeClass('is-opened');
      jQuery('.js-drawer').attr('aria-expanded', 'false').attr('aria-label', 'メニューを開く').removeClass('is-opened');
      jQuery('body').removeClass('u-overflowHidden');
    }
  });

  /* モバイル CTA スクロール表示 -------------------------------------------- */
  jQuery(window).on('load scroll', function () {
    if (!isMobile()) return;
    const scrollTop = jQuery(window).scrollTop();
    jQuery('.js-cta-buttons').toggleClass('is-visible', scrollTop > 0);
  });

  /* モバイル CTA ボタン スクロール表示 ------------------------------------------ */
  jQuery(window).on('scroll', function () {
    if (!isMobile()) return;
    const $ctaButtons = jQuery('.js-cta-buttons');
    if (!$ctaButtons.length) return;
    jQuery(this).scrollTop() > 0 ? $ctaButtons.addClass('is-visible') : $ctaButtons.removeClass('is-visible');
  });

  /* ヘッダー is-fixed ------------------------------------------------------- */
  jQuery(window).on('load scroll', function () {
    const $header = jQuery('.js-header');
    if (!$header.length) return;

    const target = jQuery(`.${$header.data('target')}`);
    const targetHeight = target.length ? target.innerHeight() : headerHeight * 1.1;
    const position = jQuery(this).scrollTop();

    if (position > targetHeight) {
      $header.addClass('is-fixed');
    } else if (position === 0) {
      $header.removeClass('is-fixed');
    }
  });

  /* スムーススクロール ------------------------------------------------------- */
  jQuery(document).on('click', 'a[href*="#"]:not(.js-tabIndex):not(.js-modal):not(.js-accordion)', function (e) {
    const currentUrl = location.protocol + '//' + location.host + location.pathname.replace(/\/$/, '');
    const href = jQuery(this).prop('href');
    const hrefUrl = href.split('#')[0].replace(/\/$/, '');

    if (currentUrl === hrefUrl) {
      e.preventDefault();
      const id = '#' + href.split('#')[1];
      const targetId = id === '#' ? 'html' : id;
      smoothScrollTo(targetId, 500);
      jQuery(this).blur();
    }
  });

  /* 電話リンク（PCのみ無効化） ----------------------------------------------- */
  const ua = navigator.userAgent;
  if (!ua.includes('iPhone') && !ua.includes('Android')) {
    jQuery('a[href^="tel:"]')
      .css({ cursor: 'default', 'pointer-events': 'none' })
      .on('click', function (e) {
        e.preventDefault();
      });
  }

  /* タブ -------------------------------------------------------------------- */
  jQuery('.js-tabIndex').on('click', function (e) {
    e.preventDefault();
    const tabParent = jQuery(this).parents('.js-tab');
    const targets = jQuery(this).data('target');
    const target = jQuery(this).attr('href');

    jQuery('.js-tabIndex.is-active').removeClass('is-active');
    jQuery(this).addClass('is-active');

    tabParent.find(`.${targets}.is-active`).removeClass('is-active');
    jQuery(target).addClass('is-active');

    return false;
  });

  /* ケース事例 アコーディオン -------------------------------------------- */
  jQuery('.js-case-accordion-btn').on('click', function () {
    const $btn = jQuery(this);
    const body = $btn.closest('.js-case-accordion').find('.case-accordion__body')[0];
    const isExpanded = $btn.attr('aria-expanded') === 'true';

    // 残存している transitionend ハンドラーを先にキャンセル
    if (body._openHandler) {
      body.removeEventListener('transitionend', body._openHandler);
      body._openHandler = null;
    }

    if (isExpanded) {
      body.style.transition = 'none';
      body.style.height = body.scrollHeight + 'px';
      body.offsetHeight; // force reflow
      body.style.transition = '';
      // 1フレーム待ってからアニメーション開始（モバイルでトランジションがスキップされる問題を防ぐ）
      requestAnimationFrame(() => {
        body.style.height = '0';
      });
      $btn.attr('aria-expanded', 'false');
      jQuery(body).attr('aria-hidden', 'true');
    } else {
      body.style.height = body.scrollHeight + 'px';
      const handler = function () {
        body.style.height = 'auto';
        body.removeEventListener('transitionend', handler);
        body._openHandler = null;
      };
      body._openHandler = handler;
      body.addEventListener('transitionend', handler);
      $btn.attr('aria-expanded', 'true');
      jQuery(body).attr('aria-hidden', 'false');
    }
  });
});
